import Kiosk from './containers/Kiosk/Kiosk';

export default Kiosk;
